import type { Role } from '@wrapforce/shared/constants';

export interface TourStep {
  anchor: string | null;
  route?: string;
  titleKey: string;
  bodyKey: string;
  // Mirrors NavItem.hiddenFor: a step whose anchor only renders for some roles
  // is dropped for the rest, rather than stalling on an anchor that is never
  // going to mount.
  hiddenFor?: Role[];
}

export interface TourDefinition {
  id: string;
  nameKey: string;
  steps: TourStep[];
  hiddenFor?: Role[];
  // Page tours opt in here: the tour runs itself the first time this exact
  // route is opened (useAutoPageTour). Feature tours that happen to start on
  // the dashboard, like the assistant one, leave it unset.
  autoRoute?: string;
}

export function visibleSteps(tour: TourDefinition, role: Role | undefined): TourStep[] {
  return tour.steps.filter((step) => !role || !step.hiddenFor?.includes(role));
}

export function visibleTours(tours: TourDefinition[], role: Role | undefined): TourDefinition[] {
  return tours.filter((tour) => (!role || !tour.hiddenFor?.includes(role)) && visibleSteps(tour, role).length > 0);
}
